<template>
  <f7-page name="control-cifras-oeb-productividad" @page:init="onPageInit" @click.native="tooltipToggle = null; tooltipKpi = null">
    <f7-navbar>
      <f7-nav-left><f7-link back icon-f7="arrow_left"></f7-link></f7-nav-left>
      <f7-nav-title>Productividad &mdash; SIMECAL</f7-nav-title>
      <f7-nav-right>
        <f7-link @click="popupInfo = !popupInfo; if (popupInfo && !instrucciones.length) cargarInstrucciones()" style="margin-right:4px"><span style="background:linear-gradient(135deg,#0F6E56,#27ae80);color:#fff;border-radius:50%;width:24px;height:24px;display:inline-flex;align-items:center;justify-content:center;font-size:13px;font-weight:700">i</span></f7-link>
        <f7-button small fill color="green" @click="guardarConfig" :disabled="guardando" style="margin-right:8px;font-size:10px">Guardar</f7-button>
        <f7-button small fill color="blue" @click="recalcular" :disabled="recalculando" style="margin-right:8px;font-size:10px" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">{{ recalculando ? 'Calculando...' : 'Recalcular' }}</f7-button>
        <f7-button small fill color="orange" @click="abrirPopupPlantilla" style="margin-right:8px;font-size:10px" v-roles="['ADMIN','DIRECTOR','DTYCAL']" icon-f7="pencil">Editar plantilla</f7-button>
        <f7-link @click="zoomOut" style="font-size:12px;min-width:20px">&minus;</f7-link>
        <span style="font-size:11px;min-width:30px;text-align:center">{{ zoom }}%</span>
        <f7-link @click="zoomIn" style="font-size:12px;min-width:20px">+</f7-link>
        <f7-link icon-f7="arrow_2_circlepath" @click="cargarDatos" title="Actualizar"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- #16 · La pantalla se sirve de oeb_productividad_cache; "Recalcular" reescribe su -->
    <!-- calculadoEn. Sustituye al antiguo "Cache: ...", que solo salia si habia fecha. -->
    <div class="sello-datos-bar">
      <sello-datos estado="fecha" :fecha="datos && datos.calculadoEn" />
    </div>

    <f7-page-content style="padding-top:0" v-roles="['ADMIN','DIRECTOR','DTYCAL','PLANIFICACION']">
      <div class="contenido-prod" :style="{ fontSize: (zoom * 0.12) + 'px' }">

        <!-- SELECTOR A&Ntilde;O -->
        <div class="anio-selector">
          <f7-link @click="anio--; cargarDatos()" icon-f7="chevron_left"></f7-link>
          <input type="number" v-model.number="anio" @change="cargarDatos" class="input-anio">
          <f7-link @click="anio++; cargarDatos()" icon-f7="chevron_right"></f7-link>
        </div>

        <!-- KPIs -->
        <div class="kpi-grid" v-if="datos">
          <div class="kpi-card kpi-editable" style="position:relative">
            <span class="kpi-info-btn" @click.stop="tooltipKpi = tooltipKpi === 0 ? null : 0">i</span>
            <div v-if="tooltipKpi === 0" class="tooltip-info tooltip-info-kpi" @click.stop>{{ kpisDef[0].desc }}</div>
            <div class="kpi-label">Horas lab. anuales <info-icon dominio="oeb" clave="OEB_HorasLabAnuales" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></div>
            <div class="kpi-val"><input type="number" class="kpi-input-edit" v-model.number="configLocal.horasLaborablesAnuales"></div>
          </div>
          <div class="kpi-card kpi-fichadas" style="position:relative">
            <span class="kpi-info-btn" @click.stop="tooltipKpi = tooltipKpi === 1 ? null : 1">i</span>
            <div v-if="tooltipKpi === 1" class="tooltip-info tooltip-info-kpi" @click.stop>{{ kpisDef[1].desc }}</div>
            <div class="kpi-label">Horas fichadas acum. <info-icon dominio="oeb" clave="OEB_HorasFichadasAcum" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></div>
            <div class="kpi-val">{{ kpiHorasFichadas }}</div>
          </div>
          <div class="kpi-card kpi-editable" style="position:relative">
            <span class="kpi-info-btn" @click.stop="tooltipKpi = tooltipKpi === 2 ? null : 2">i</span>
            <div v-if="tooltipKpi === 2" class="tooltip-info tooltip-info-kpi" @click.stop>{{ kpisDef[2].desc }}</div>
            <div class="kpi-label">D&iacute;as vac. convenio <info-icon dominio="oeb" clave="OEB_DiasVacConvenio" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></div>
            <div class="kpi-val"><input type="number" class="kpi-input-edit" v-model.number="configLocal.diasVacacionesConvenio"></div>
          </div>
          <div class="kpi-card kpi-vac-cons" style="position:relative">
            <span class="kpi-info-btn" @click.stop="tooltipKpi = tooltipKpi === 3 ? null : 3">i</span>
            <div v-if="tooltipKpi === 3" class="tooltip-info tooltip-info-kpi" @click.stop>{{ kpisDef[3].desc }}</div>
            <div class="kpi-label">Vac. consumidas <info-icon dominio="oeb" clave="OEB_VacConsumidas" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></div>
            <div class="kpi-val">{{ kpiVacConsumidas }} <span style="font-size:11px">d&iacute;as</span></div>
          </div>
          <div class="kpi-card kpi-vac-rest" style="position:relative">
            <span class="kpi-info-btn" @click.stop="tooltipKpi = tooltipKpi === 4 ? null : 4">i</span>
            <div v-if="tooltipKpi === 4" class="tooltip-info tooltip-info-kpi" @click.stop>{{ kpisDef[4].desc }}</div>
            <div class="kpi-label">Vac. restantes <info-icon dominio="oeb" clave="OEB_VacRestantes" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></div>
            <div class="kpi-val">{{ kpiVacRestantes }} <span style="font-size:11px">d&iacute;as</span></div>
          </div>
          <div class="kpi-card kpi-comp" style="position:relative">
            <span class="kpi-info-btn" @click.stop="tooltipKpi = tooltipKpi === 5 ? null : 5">i</span>
            <div v-if="tooltipKpi === 5" class="tooltip-info tooltip-info-kpi" @click.stop>{{ kpisDef[5].desc }}</div>
            <div class="kpi-label">Horas comp. <info-icon dominio="oeb" clave="OEB_CO" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></div>
            <div class="kpi-val">{{ kpiHorasComp }}</div>
          </div>
          <div class="kpi-card kpi-precio" style="position:relative">
            <span class="kpi-info-btn" @click.stop="tooltipKpi = tooltipKpi === 6 ? null : 6">i</span>
            <div v-if="tooltipKpi === 6" class="tooltip-info tooltip-info-kpi" @click.stop>{{ kpisDef[6].desc }}</div>
            <div class="kpi-label">Precio medio persona/h <info-icon dominio="oeb" clave="OEB_PrecioMedioHora" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></div>
            <div class="kpi-val">{{ kpiPrecioMedioH }}</div>
          </div>
          <div class="kpi-card kpi-fichadas" style="position:relative">
            <span class="kpi-info-btn" @click.stop="tooltipKpi = tooltipKpi === 7 ? null : 7">i</span>
            <div v-if="tooltipKpi === 7" class="tooltip-info tooltip-info-kpi" @click.stop>{{ kpisDef[7].desc }}</div>
            <div class="kpi-label">N&ordm; H. I/C <info-icon dominio="oeb" clave="OEB_NumHIC" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></div>
            <div class="kpi-val">{{ fmtNum(kpiNumHIC) }}</div>
          </div>
          <div class="kpi-card kpi-prodpers" style="position:relative">
            <span class="kpi-info-btn" @click.stop="tooltipKpi = tooltipKpi === 8 ? null : 8">i</span>
            <div v-if="tooltipKpi === 8" class="tooltip-info tooltip-info-kpi" @click.stop>{{ kpisDef[8].desc }}</div>
            <div class="kpi-label">Precio medio I/C/h <info-icon dominio="oeb" clave="OEB_PrecioMedioICH" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></div>
            <div class="kpi-val">{{ kpiPrecioMedioICH }} &euro;</div>
          </div>
          <div class="kpi-card kpi-prodpers" style="position:relative">
            <span class="kpi-info-btn" @click.stop="tooltipKpi = tooltipKpi === 9 ? null : 9">i</span>
            <div v-if="tooltipKpi === 9" class="tooltip-info tooltip-info-kpi" @click.stop>{{ kpisDef[9].desc }}</div>
            <div class="kpi-label">Prod/persona <info-icon dominio="oeb" clave="OEB_ProdPorPersona" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></div>
            <div class="kpi-val">{{ fmtNum(prodPorPersona) }} &euro;</div>
          </div>
          <div class="kpi-card kpi-prodic" style="position:relative">
            <span class="kpi-info-btn" @click.stop="tooltipKpi = tooltipKpi === 10 ? null : 10">i</span>
            <div v-if="tooltipKpi === 10" class="tooltip-info tooltip-info-kpi" @click.stop>{{ kpisDef[10].desc }}</div>
            <div class="kpi-label">Productividad I/C <info-icon dominio="oeb" clave="OEB_ProdIc" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></div>
            <div class="kpi-val">{{ kpiProdIc }} <span style="font-size:11px">&euro;</span></div>
          </div>
        </div>

        <!-- TOGGLES -->
        <div class="toggles-prod" v-if="datos">
          <div v-for="td in togglesDef" :key="td.clave" class="t-btn" :style="tStyle(td.color, toggles[td.clave])" @click="toggles[td.clave] = !toggles[td.clave]" style="display:inline-flex;align-items:center;gap:3px">
            <span v-html="td.nombre"></span>
            <info-icon dominio="oeb" :clave="td.claveConcepto" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" />
          </div>
          <div class="t-btn" :style="tStyle('#0B5345', toggles.soloProduccion)" @click="toggles.soloProduccion = !toggles.soloProduccion">Producci&oacute;n</div>
          <div class="t-btn" style="background:#1a2744;color:#fff;border:1px solid #1a2744" @click="personasOcultas = {}">Mostrar todos</div>
          <span v-if="numOcultas > 0" style="font-size:10px;color:#dc3545;margin-left:2px;align-self:center">({{ numOcultas }} ocultas)</span>
        </div>
        <!-- TOOLTIP TOGGLE (fixed, fuera del overflow) -->
        <div v-if="tooltipToggle !== null" class="tooltip-overlay" @click="tooltipToggle = null">
          <div class="tooltip-fixed" :style="tooltipTogglePos" @click.stop>
            <div style="font-weight:600;margin-bottom:3px">{{ tooltipToggleData.nombre }}</div>
            {{ tooltipToggleData.desc }}
          </div>
        </div>

        <!-- CARGANDO -->
        <div v-if="cargando" style="text-align:center;padding:40px;color:#999">
          <f7-preloader></f7-preloader>
          <p>Cargando datos anuales...</p>
        </div>

        <!-- TABLA PRINCIPAL -->
        <div class="tabla-wrap" v-if="datos && personasFiltradas.length">
          <div class="tabla-scroll">
            <table class="tabla-prod">
              <thead>
                <tr>
                  <th class="col-sticky col-codigo th-orden" @click="ordenarPor('codigo')" title="Ordenar por c&oacute;digo">C&Oacute;D <span class="orden-ind" :class="{'orden-ind-activo': orden.campo === 'codigo'}">{{ indicadorOrden('codigo') }}</span> <span @click.stop="popupFiltro = !popupFiltro" style="cursor:pointer;font-size:11px;color:#a8cceb">&#9660;</span></th>
                  <th class="col-mes" v-for="m in 12" :key="'h-'+m" :class="claseColumnaMes(m)">{{ nombreMesCorto(m) }}</th>
                  <th class="col-total col-sep-left th-orden" @click="ordenarPor('total')" title="Ordenar por total">TOTAL <span class="orden-ind" :class="{'orden-ind-activo': orden.campo === 'total'}">{{ indicadorOrden('total') }}</span></th>
                  <th class="col-num col-sep-left">Prod/<br>d&iacute;a</th>
                  <th class="col-num">Prod/<br>h</th>
                  <th class="col-num col-sep-left">Vac<br>acum</th>
                  <th class="col-num">Vac<br>rest</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(persona, pidx) in personasOrdenadas" :key="persona.codigo"
                    :class="pidx % 2 === 1 ? 'fila-alt' : ''" class="fila-persona">
                  <td class="col-sticky col-codigo"><span @click.stop="$set(personasOcultas, persona.codigo, true)" style="cursor:pointer;color:#dc3545;font-size:8px;margin-right:2px" title="Ocultar persona">&#9679;</span><strong>{{ persona.codigo }}</strong><span @click.stop="mostrarNombrePersona(persona)" style="cursor:pointer;color:#2d5f8a;font-size:9px;margin-left:2px" title="Ver nombre">&#128100;</span></td>
                  <td class="col-mes" v-for="m in 12" :key="'c-'+persona.codigo+'-'+m"
                      :class="claseColumnaMes(m)"
                      style="position:relative">
                    <span v-if="getNumPersonaMes(persona, m) > 0" style="position:absolute;top:0;left:1px;font-size:7px;color:#bbb;line-height:1">{{ getNumPersonaMes(persona, m) }}</span>
                    <div class="celda-mes" v-if="persona.meses && persona.meses[m-1]">
                      <div v-if="toggles.tpc" class="val-line"><span class="vdot" style="background:#dc3545"></span>{{ fmtNum(persona.meses[m-1].tpcSi) }}</div>
                      <div v-if="toggles.dh" class="val-line"><span class="vdot" style="background:#6c757d"></span>{{ persona.meses[m-1].dh }}</div>
                      <div v-if="toggles.vac" class="val-line"><span class="vdot" style="background:#e6a817"></span>{{ persona.meses[m-1].vac }}</div>
                      <div v-if="toggles.bl" class="val-line"><span class="vdot" style="background:#B71C1C"></span>{{ persona.meses[m-1].bl }}</div>
                      <div v-if="toggles.dr" class="val-line"><span class="vdot" style="background:#555"></span>{{ persona.meses[m-1].dr }}</div>
                      <div v-if="toggles.hFichaje" class="val-line" @click.stop="abrirFichajeDetalle(persona, m)" style="cursor:pointer"><span class="vdot" style="background:#0d6efd"></span>{{ persona.meses[m-1].horasFichaje > 0 ? fmtDec(persona.meses[m-1].horasFichaje) : '&mdash;' }}</div>
                      <div v-if="toggles.hMensuales" class="val-line"><span class="vdot" style="background:#7B2D8E"></span>{{ fmtDec(persona.meses[m-1].hMensuales) }}</div>
                      <div v-if="toggles.deltaH" class="val-line"><span class="vdot" style="background:#E65100"></span><span v-if="getDeltaH(persona, m) !== null" :style="{color: getDeltaH(persona, m) > 0.5 ? '#198754' : getDeltaH(persona, m) < -0.5 ? '#dc3545' : '#666'}">{{ getDeltaH(persona, m) > 0 ? '+' : '' }}{{ fmtDec(getDeltaH(persona, m)) }}</span><span v-else>&mdash;</span></div>
                      <div v-if="toggles.sumDeltaH" class="val-line"><span class="vdot" style="background:#BF360C"></span><span v-if="getSumDeltaH(persona, m) !== null" :style="{color: getSumDeltaH(persona, m) > 0.5 ? '#198754' : getSumDeltaH(persona, m) < -0.5 ? '#dc3545' : '#666', fontWeight: '700'}">{{ getSumDeltaH(persona, m) > 0 ? '+' : '' }}{{ fmtDec(getSumDeltaH(persona, m)) }}</span><span v-else>&mdash;</span></div>
                      <div v-if="toggles.numIc" class="val-line"><span class="vdot" style="background:#198754"></span>{{ persona.meses[m-1].numIc }}</div>
                      <div v-if="toggles.comp" class="val-line"><span class="vdot" style="background:#e6a817"></span>{{ fmtDec(persona.meses[m-1].comp) }}</div>
                      <div v-if="toggles.prodDia" class="val-line"><span class="vdot" style="background:#1a2744"></span>{{ fmtNum(persona.meses[m-1].prodDia) }}</div>
                      <div v-if="toggles.prodH" class="val-line"><span class="vdot" style="background:#1a2744"></span>{{ fmtNum(persona.meses[m-1].prodH) }}</div>
                    </div>
                    <span v-else class="mes-vacio">&mdash;</span>
                  </td>
                  <td class="col-total col-sep-left"><strong>{{ fmtNum(persona.totalTpc) }}</strong></td>
                  <td class="col-num col-sep-left" style="text-align:right">{{ fmtNum(persona.prodDia) }}</td>
                  <td class="col-num" style="text-align:right">{{ fmtNum(persona.prodH) }}</td>
                  <td class="col-num col-sep-left" style="text-align:right">{{ persona.totalVac || 0 }}</td>
                  <td class="col-num" style="text-align:right">{{ vacRestantes(persona) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="fila-totales">
                  <td class="col-sticky col-codigo"><strong>TOTAL</strong></td>
                  <td class="col-mes" v-for="m in 12" :key="'t-'+m" :class="claseColumnaMes(m)">
                    <div class="celda-mes" v-if="totalMes(m)">
                      <div v-if="toggles.tpc" class="val-line"><span class="vdot" style="background:#dc3545"></span><strong>{{ fmtNum(totalMes(m).tpcSi) }}</strong></div>
                      <div v-if="toggles.dh" class="val-line"><span class="vdot" style="background:#6c757d"></span><strong>{{ totalMes(m).dh }}</strong></div>
                      <div v-if="toggles.vac" class="val-line"><span class="vdot" style="background:#e6a817"></span><strong>{{ totalMes(m).vac }}</strong></div>
                      <div v-if="toggles.bl" class="val-line"><span class="vdot" style="background:#B71C1C"></span><strong>{{ totalMes(m).bl }}</strong></div>
                      <div v-if="toggles.dr" class="val-line"><span class="vdot" style="background:#555"></span><strong>{{ totalMes(m).dr }}</strong></div>
                      <div v-if="toggles.hFichaje" class="val-line"><span class="vdot" style="background:#0d6efd"></span><strong>{{ totalMes(m).horasFichaje > 0 ? fmtDec(totalMes(m).horasFichaje) : '&mdash;' }}</strong></div>
                      <div v-if="toggles.hMensuales" class="val-line"><span class="vdot" style="background:#7B2D8E"></span><strong>{{ fmtDec(totalMes(m).hMensuales) }}</strong></div>
                      <div v-if="toggles.deltaH" class="val-line"><span class="vdot" style="background:#E65100"></span><strong :style="{color: getTotalDeltaH(m) > 0 ? '#198754' : '#dc3545'}">{{ getTotalDeltaH(m) > 0 ? '+' : '' }}{{ fmtDec(getTotalDeltaH(m)) }}</strong></div>
                      <div v-if="toggles.sumDeltaH" class="val-line"><span class="vdot" style="background:#BF360C"></span><strong :style="{color: getTotalSumDeltaH(m) > 0 ? '#198754' : '#dc3545'}">{{ getTotalSumDeltaH(m) > 0 ? '+' : '' }}{{ fmtDec(getTotalSumDeltaH(m)) }}</strong></div>
                      <div v-if="toggles.numIc" class="val-line"><span class="vdot" style="background:#198754"></span><strong>{{ fmtDec(totalMes(m).numIc) }}</strong></div>
                      <div v-if="toggles.comp" class="val-line"><span class="vdot" style="background:#e6a817"></span><strong>{{ fmtDec(totalMes(m).comp) }}</strong></div>
                      <div v-if="toggles.prodDia" class="val-line"><span class="vdot" style="background:#1a2744"></span><strong>{{ fmtNum(totalMes(m).prodDia) }}</strong></div>
                      <div v-if="toggles.prodH" class="val-line"><span class="vdot" style="background:#1a2744"></span><strong>{{ fmtNum(totalMes(m).prodH) }}</strong></div>
                    </div>
                    <span v-else>&mdash;</span>
                  </td>
                  <td class="col-total col-sep-left"><strong>{{ fmtNum(grandTotal.tpc) }}</strong></td>
                  <td class="col-num col-sep-left" style="text-align:right;font-weight:600">{{ fmtNum(grandTotal.prodDia) }}</td>
                  <td class="col-num" style="text-align:right;font-weight:600">{{ fmtNum(grandTotal.prodH) }}</td>
                  <td class="col-num col-sep-left" style="text-align:right;font-weight:600">{{ grandTotal.vac }}</td>
                  <td class="col-num" style="text-align:right;font-weight:600">{{ grandTotal.vacRest }}</td>
                </tr>
                <tr class="fila-num-ic">
                  <td class="col-sticky col-codigo"><strong>N&ordm; I/C</strong></td>
                  <td class="col-mes" v-for="m in 12" :key="'ic-'+m" style="text-align:center;font-size:10px;color:#198754">
                    {{ totalMes(m) && totalMes(m).numIc > 0 ? fmtDec(totalMes(m).numIc) : '' }}
                  </td>
                  <td class="col-total col-sep-left" style="color:#198754">{{ fmtDec(grandTotalNumIc) }}</td>
                  <td colspan="4" class="col-sep-left"></td>
                </tr>
                <tr class="fila-prod-ic">
                  <td class="col-sticky col-codigo"><strong>PROD/I/C</strong></td>
                  <td class="col-mes" v-for="m in 12" :key="'pic-'+m" style="text-align:center;font-size:10px;color:#198754">
                    {{ totalMes(m) && totalMes(m).numIc > 0 ? fmtNum(Math.round(totalMes(m).tpcSi / totalMes(m).numIc)) : '' }}
                  </td>
                  <td class="col-total col-sep-left" style="color:#198754">{{ fmtNum(mediaProdIC) }}</td>
                  <td colspan="4" class="col-sep-left"></td>
                </tr>
                <tr class="fila-num-hic">
                  <td class="col-sticky col-codigo"><strong>N&ordm; H. I/C</strong></td>
                  <td class="col-mes" v-for="m in 12" :key="'hic-'+m" style="text-align:center;font-size:10px;color:#0C447C">
                    {{ totalMes(m) && totalMes(m).hMensuales > 0 ? fmtDec(totalMes(m).hMensuales) : '' }}
                  </td>
                  <td class="col-total col-sep-left" style="color:#0C447C">{{ fmtNum(kpiNumHIC) }}</td>
                  <td colspan="4" class="col-sep-left"></td>
                </tr>
                <tr class="fila-prod-hic">
                  <td class="col-sticky col-codigo"><strong>PROD/H.I/C</strong></td>
                  <td class="col-mes" v-for="m in 12" :key="'phic-'+m" style="text-align:center;font-size:10px;color:#0C447C">
                    {{ totalMes(m) && totalMes(m).hMensuales > 0 ? fmtDec(totalMes(m).tpcSi / totalMes(m).hMensuales) : '' }}
                  </td>
                  <td class="col-total col-sep-left" style="color:#0C447C">{{ fmtDec(mediaProdHIC) }}</td>
                  <td colspan="4" class="col-sep-left"></td>
                </tr>
                <tr class="fila-personas">
                  <td class="col-sticky col-codigo" style="font-size:9px"><strong>PERSONAS</strong></td>
                  <td class="col-mes" v-for="m in 12" :key="'pe-'+m"
                      :style="{textAlign:'center', fontSize:'10px', color:'#666', background: esMesManual(m) ? '#FEF3C7' : ''}"
                      :title="tooltipMesManual(m)">{{ fmtPersonas(getPersonasProporcionalMes(m)) }}</td>
                  <td class="col-total col-sep-left" style="font-size:10px">{{ fmtPersonas(mediaPersonasMes) }}</td>
                  <td colspan="4" class="col-sep-left" style="font-size:10px;text-align:left;padding-left:6px">
                    Prod: {{ datos.personasConProduccion || 0 }}
                  </td>
                </tr>
                <tr class="fila-prod-persona">
                  <td class="col-sticky col-codigo"><strong>PROD/P</strong></td>
                  <td class="col-mes" v-for="m in 12" :key="'pp-'+m" style="text-align:center;font-size:10px">
                    <span v-if="totalMes(m) && totalMes(m).tpcSi > 0 && getPersonasProporcionalMes(m) > 0">{{ fmtNum(Math.round(totalMes(m).tpcSi / getPersonasProporcionalMes(m))) }}</span>
                  </td>
                  <td class="col-total col-sep-left"><strong>{{ fmtNum(prodPorPersona) }}</strong></td>
                  <td colspan="4" class="col-sep-left"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>

        <!-- POPUP FILTRO PERSONAS -->
        <div v-if="popupFiltro" class="filtro-overlay" @click="popupFiltro = false">
          <div class="filtro-popup" @click.stop>
            <div style="padding:8px 10px;border-bottom:1px solid #eee;display:flex;gap:8px;align-items:center">
              <strong style="font-size:12px;color:#1a2744">Filtrar personas</strong>
              <span @click="seleccionarTodas" style="cursor:pointer;color:#198754;font-size:11px;font-weight:600;margin-left:auto">Todas</span>
              <span @click="deseleccionarTodas" style="cursor:pointer;color:#dc3545;font-size:11px;font-weight:600">Ninguna</span>
              <span @click="popupFiltro=false" style="cursor:pointer;color:#999;font-size:14px;margin-left:8px">&#10005;</span>
            </div>
            <div style="max-height:400px;overflow-y:auto">
              <div v-for="p in todasLasPersonas" :key="'fp-'+p.codigo" style="padding:3px 10px;font-size:11px;white-space:nowrap">
                <label style="display:flex;align-items:center;gap:4px;cursor:pointer">
                  <input type="checkbox" :checked="!personasOcultas[p.codigo]" @change="togglePersona(p.codigo)">
                  <strong>{{ p.codigo }}</strong>
                  <span style="color:#888">{{ p.nombre !== p.codigo ? p.nombre : '' }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- POPUP FICHAJE DETALLE -->
        <div v-if="popupFichaje" class="fichaje-overlay" @click="popupFichaje = false">
          <div class="fichaje-popup" @click.stop>
            <div class="fichaje-header">
              <div style="display:flex;align-items:center;gap:8px">
                <span @click="navFichajeMes(-1)" style="cursor:pointer;font-size:16px">&lsaquo;</span>
                <strong>{{ fichajeDetalle ? fichajeDetalle.nombre : fichajePersonaCod }}</strong>
                <span style="font-size:12px;color:#a8cceb">{{ nombresMeses[fichajeMes - 1] }} {{ anio }}</span>
                <span @click="navFichajeMes(1)" style="cursor:pointer;font-size:16px">&rsaquo;</span>
              </div>
              <span @click="popupFichaje = false" style="cursor:pointer;font-size:18px;color:#a8cceb">&times;</span>
            </div>
            <div v-if="cargandoFichaje" style="text-align:center;padding:30px;color:#999"><f7-preloader></f7-preloader></div>
            <template v-if="fichajeDetalle && !cargandoFichaje">
              <div class="fichaje-kpis">
                <div class="fk-card fk-azul"><div class="fk-label">Total fichado</div><div class="fk-val">{{ fmtMinToH(fichajeDetalle.totalMinutosMes) }}</div></div>
                <div class="fk-card fk-purpura"><div class="fk-label">D&iacute;as fichados</div><div class="fk-val">{{ fichajeDetalle.diasFichados }}</div></div>
                <div class="fk-card" :class="fichajeDetalleDelta >= 0 ? 'fk-verde' : 'fk-rojo'"><div class="fk-label">&Delta;H (fich&minus;mens)</div><div class="fk-val">{{ fichajeDetalleDelta >= 0 ? '+' : '' }}{{ fmtDec(fichajeDetalleDelta) }}h</div></div>
              </div>
              <div class="fichaje-tabla-wrap">
                <table class="fichaje-tabla">
                  <thead><tr><th style="width:35px">D&iacute;a</th><th style="width:30px"></th><th>Entradas / Salidas</th><th style="width:60px;text-align:right">Total</th></tr></thead>
                  <tbody>
                    <tr v-for="d in fichajeDetalle.dias" :key="d.dia" :class="{'fich-finde': d.diaSemana >= 6 && !d.ausencia, 'fich-vacio': d.registros.length === 0 && d.diaSemana < 6 && !d.ausencia, 'fich-vac': d.ausencia === 'VACACIONES', 'fich-baja': d.ausencia === 'BAJA LABORAL', 'fich-fiesta': d.ausencia === 'FIESTA', 'fich-comp': d.ausencia === 'COMPENSACI\u00d3N'}">
                      <td style="text-align:center;font-weight:600">{{ d.dia }}</td>
                      <td style="font-size:10px;color:#888">{{ fmtDiaSemana(d.diaSemana) }}</td>
                      <td>
                        <span v-if="d.ausencia === 'VACACIONES'" style="color:#856404;font-size:11px;font-weight:500;background:#FFF9E6;padding:1px 6px;border-radius:3px">VACACIONES</span>
                        <span v-if="d.ausencia === 'BAJA LABORAL'" style="color:#991B1B;font-size:11px;font-weight:500;background:#FEE2E2;padding:1px 6px;border-radius:3px">BAJA LABORAL</span>
                        <span v-if="d.ausencia === 'FIESTA'" style="color:#0C447C;font-size:11px;font-weight:500;background:#E6F1FB;padding:1px 6px;border-radius:3px">FIESTA</span>
                        <span v-if="d.ausencia === 'COMPENSACI\u00d3N'" style="color:#5B21B6;font-size:11px;font-weight:500;background:#EDE9FE;padding:1px 6px;border-radius:3px">COMP. {{ d.compHoras ? d.compHoras.toFixed(1) + 'h' : '' }}</span>
                        <span v-if="d.registros.length > 0" class="fich-rangos" :style="d.ausencia ? 'margin-left:6px' : ''">
                          <template v-for="(r, ri) in d.registros"><span :key="ri" :style="{color: r.tipo === 'ENTRADA' ? '#198754' : '#dc3545', fontWeight: '500'}">{{ r.hora }}</span><span v-if="ri < d.registros.length - 1" :key="'s'+ri" style="color:#bbb;margin:0 2px">{{ r.tipo === 'ENTRADA' ? '&rarr;' : '&middot;' }}</span></template>
                        </span>
                        <span v-if="d.registros.length === 0 && !d.ausencia" style="color:#ccc">&mdash;</span>
                      </td>
                      <td style="text-align:right;font-weight:500">{{ d.totalMinutos > 0 ? fmtMinToH(d.totalMinutos) : '' }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr style="font-weight:700;border-top:2px solid #1a2744;background:#eef1f7">
                      <td colspan="3" style="text-align:right;padding-right:8px">TOTAL ({{ fichajeDetalle.diasFichados }} d&iacute;as)</td>
                      <td style="text-align:right">{{ fmtMinToH(fichajeDetalle.totalMinutosMes) }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </template>
          </div>
        </div>

        <!-- POPUP GUIA DE USO -->
        <div v-if="popupInfo" class="guia-overlay" @click="popupInfo = false">
          <div class="guia-popup" @click.stop>
            <div class="guia-hdr">
              <div style="display:flex;align-items:center;gap:10px">
                <span style="font-size:24px">&#128202;</span>
                <div><div style="font-size:16px;font-weight:800;color:#fff">Gu&iacute;a de uso</div><div style="font-size:10px;color:rgba(255,255,255,.6)">PRODUCTIVIDAD OEB</div></div>
              </div>
              <div style="display:flex;align-items:center;gap:6px">
                <span style="background:rgba(255,255,255,.2);border-radius:12px;padding:3px 10px;font-size:10px;font-weight:700;color:#fff">{{ instrucciones.length }}</span>
                <span @click="popupInfo = false" style="width:28px;height:28px;border-radius:6px;border:1px solid rgba(255,255,255,.25);background:rgba(255,255,255,.1);color:#fff;font-size:14px;cursor:pointer;display:flex;align-items:center;justify-content:center">&times;</span>
              </div>
            </div>
            <div style="padding:8px 16px;flex-shrink:0">
              <div style="position:relative;display:flex;align-items:center">
                <span style="position:absolute;left:10px;font-size:13px;color:#94a3b8">&#128269;</span>
                <input v-model="buscarInstr" placeholder="Buscar..." style="width:100%;padding:8px 8px 8px 32px;border:1px solid #e2e8f0;border-radius:8px;font-size:13px;outline:none">
                <span v-if="buscarInstr" @click="buscarInstr = ''" style="position:absolute;right:8px;cursor:pointer;color:#94a3b8;font-size:14px">&times;</span>
              </div>
            </div>
            <div style="flex:1;overflow-y:auto;padding:0 16px 16px;background:linear-gradient(180deg,#f8fafc,#f0f2f5)">
              <div v-for="(inst, idx) in instFiltradas" :key="inst.id || idx" style="background:#fff;border-radius:10px;border:1px solid #e2e8f0;border-left:3px solid #1a2744;margin-bottom:8px;box-shadow:0 1px 3px rgba(0,0,0,.04)">
                <div @click="expandedInst = expandedInst === idx ? null : idx" style="display:flex;gap:10px;padding:10px;cursor:pointer;align-items:center">
                  <span style="min-width:26px;height:26px;background:#1a2744;color:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:800">{{ inst.orden || idx + 1 }}</span>
                  <span style="flex:1;font-size:13px;font-weight:600;color:#1e293b">{{ inst.titulo }}</span>
                  <span style="font-size:10px;color:#94a3b8">{{ expandedInst === idx ? '&#9650;' : '&#9660;' }}</span>
                </div>
                <div v-if="expandedInst === idx" style="padding:0 12px 12px;border-top:1px solid #f1f5f9">
                  <div style="font-size:12.5px;line-height:1.6;color:#334155;padding-top:8px">{{ inst.texto }}</div>
                </div>
              </div>
              <div v-if="!instFiltradas.length" style="text-align:center;padding:40px;font-size:12px;color:#94a3b8">Sin resultados</div>
            </div>
          </div>
        </div>

        <!-- LEYENDA -->
        <div class="leyenda-prod" v-if="datos">
          <span class="ley-item"><span class="ley-dot" style="background:#dc3545"></span> TPC(SI) &euro; <info-icon dominio="oeb" clave="OEB_TPC_SI" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></span>
          <span class="ley-item"><span class="ley-dot" style="background:#6c757d"></span> D&iacute;as h&aacute;biles <info-icon dominio="oeb" clave="OEB_DH" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></span>
          <span class="ley-item"><span class="ley-dot" style="background:#e6a817"></span> Vacaciones <info-icon dominio="oeb" clave="OEB_VAC" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></span>
          <span class="ley-item"><span class="ley-dot" style="background:#B71C1C"></span> Bajas laborales <info-icon dominio="oeb" clave="OEB_BL" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></span>
          <span class="ley-item"><span class="ley-dot" style="background:#555"></span> D&iacute;as reales <info-icon dominio="oeb" clave="OEB_DR" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></span>
          <span class="ley-item"><span class="ley-dot" style="background:#0d6efd"></span> Horas fichaje (reales) <info-icon dominio="oeb" clave="OEB_HorasFichaje" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></span>
          <span class="ley-item"><span class="ley-dot" style="background:#7B2D8E"></span> Horas mensuales (estimadas) <info-icon dominio="oeb" clave="OEB_HorasMensuales" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></span>
          <span class="ley-item"><span class="ley-dot" style="background:#E65100"></span> &Delta;H (H.fich &minus; H.mens) <info-icon dominio="oeb" clave="OEB_DeltaH" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></span>
          <span class="ley-item"><span class="ley-dot" style="background:#BF360C"></span> &Sigma;&Delta;H acumulado <info-icon dominio="oeb" clave="OEB_SumDeltaH" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></span>
          <span class="ley-item"><span class="ley-dot" style="background:#198754"></span> N&ordm; I/C <info-icon dominio="oeb" clave="OEB_NumIC" criticidad="CRITICO" pantalla="control-cifras-oeb-productividad" /></span>
        </div>

        <div v-if="datos" style="padding:8px 16px;font-size:11px;color:#999">
          Meses vencidos: {{ datos.mesesVencidos }} &middot; Solo meses vencidos se usan para los res&uacute;menes
          &middot; Personas totales: {{ datos.totalPersonas || 0 }} &middot; Con producci&oacute;n: {{ datos.personasConProduccion || 0 }}
        </div>

      </div>
    </f7-page-content>

    <!-- POPUP EDITAR PLANTILLA PERSONAS -->
    <f7-popup :opened="popupPlantillaAbierto" @popup:closed="popupPlantillaAbierto = false" style="--f7-popup-tablet-width: 720px">
      <f7-page>
        <f7-navbar :title="'Editar plantilla PERSONAS — Año ' + anio">
          <f7-nav-right>
            <f7-link popup-close icon-f7="xmark"></f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-page-content>
          <div style="padding:16px">
            <div style="font-size:13px;color:#64748b;margin-bottom:16px;line-height:1.5">
              Introduce el n&uacute;mero total de trabajadores de la empresa para cada mes.
              Si dejas un valor en blanco, el sistema usar&aacute; el c&aacute;lculo autom&aacute;tico
              (proporcional por d&iacute;as fichados + 2 aut&oacute;nomos). Puedes a&ntilde;adir un
              comentario para documentar cambios de plantilla.
            </div>
            <div v-for="m in 12" :key="'plantilla-'+m"
                 style="display:grid;grid-template-columns:110px 120px 1fr;gap:12px;align-items:center;margin-bottom:10px;padding:10px;background:#f8fafc;border-radius:6px">
              <div style="font-weight:600;color:#1a2744;font-size:13px">{{ nombreMesLargo(m) }}</div>
              <input type="number" step="0.1" min="0"
                     v-model.number="plantillaPersonasEdit[m].totalPersonas"
                     placeholder="Auto"
                     style="padding:6px 10px;border:1px solid #d1d5db;border-radius:4px;font-size:13px;width:100%">
              <input type="text"
                     v-model="plantillaPersonasEdit[m].comentario"
                     placeholder="Comentario (opcional)"
                     style="padding:6px 10px;border:1px solid #d1d5db;border-radius:4px;font-size:13px;width:100%">
            </div>
            <div style="display:flex;gap:10px;justify-content:flex-end;margin-top:20px">
              <button @click="popupPlantillaAbierto = false"
                      :disabled="plantillaGuardando"
                      style="padding:8px 16px;border:1px solid #d1d5db;border-radius:4px;background:white;cursor:pointer">Cancelar</button>
              <button @click="guardarPlantilla"
                      :disabled="plantillaGuardando"
                      style="padding:8px 16px;border:none;border-radius:4px;background:#1A2744;color:white;cursor:pointer">
                {{ plantillaGuardando ? 'Guardando...' : 'Guardar' }}
              </button>
            </div>
          </div>
        </f7-page-content>
      </f7-page>
    </f7-popup>

  </f7-page>
</template>

<style scoped>
.contenido-prod { padding:8px 12px; }

/* Selector a&ntilde;o */
.anio-selector { display:flex; align-items:center; justify-content:center; gap:12px; padding:12px 0; }
.input-anio { width:80px; text-align:center; font-size:18px; font-weight:700; border:1px solid #ddd; border-radius:6px; padding:4px 8px; color:#1a2744; }

/* KPIs */
.kpi-grid { display:grid; grid-template-columns:repeat(auto-fit, minmax(130px, 1fr)); gap:8px; padding:0 0 12px; }
.kpi-card { border-radius:0.6em; padding:0.8em 1em; text-align:center; background:#fff; border:1px solid #e0e0e0; }
.kpi-label { font-size:10px; text-transform:uppercase; letter-spacing:0.5px; font-weight:600; color:#7c8db0; margin-bottom:4px; }
.kpi-val { font-size:20px; font-weight:700; color:#1a2744; margin-top:4px; }
.kpi-editable { background:#fff; border:2px solid #1a2744; }
.kpi-input-edit { width:70px; text-align:center; font-size:18px; font-weight:700; color:#1a2744; background:transparent; border:none; border-bottom:2px dashed #1a2744; outline:none; }
.kpi-fichadas { background:#E6F1FB; border-color:#E6F1FB; }
.kpi-fichadas .kpi-label { color:#0C447C; }
.kpi-fichadas .kpi-val { color:#0C447C; }
.kpi-vac-cons { background:#FFF9E6; border-color:#FFF9E6; }
.kpi-vac-cons .kpi-label { color:#856404; }
.kpi-vac-cons .kpi-val { color:#856404; }
.kpi-vac-rest { background:#E8F5E9; border-color:#E8F5E9; }
.kpi-vac-rest .kpi-label { color:#1B5E20; }
.kpi-vac-rest .kpi-val { color:#1B5E20; }
.kpi-comp { background:#EDE9FE; border-color:#EDE9FE; }
.kpi-comp .kpi-label { color:#5B21B6; }
.kpi-comp .kpi-val { color:#5B21B6; }
.kpi-precio { background:#E6F1FB; border-color:#E6F1FB; }
.kpi-precio .kpi-label { color:#0C447C; }
.kpi-precio .kpi-val { color:#0C447C; }
.kpi-prodpers { background:#1a2744; border-color:#1a2744; }
.kpi-prodpers .kpi-label { color:#a8cceb; }
.kpi-prodpers .kpi-val { color:#fff; }
.kpi-prodic { background:#0F6E56; border-color:#0F6E56; }
.kpi-prodic .kpi-label { color:rgba(255,255,255,0.7); }
.kpi-prodic .kpi-val { color:#fff; }

/* Toggles */
.toggles-prod { display:flex; flex-wrap:wrap; gap:6px; padding:0 0 12px; align-items:center; }
.t-btn { font-size:10px; font-weight:600; padding:4px 10px; border-radius:4px; cursor:pointer; user-select:none; transition:all 0.15s; white-space:nowrap; }
.toggle-info-btn { width:13px; height:13px; background:rgba(255,255,255,0.3); border-radius:50%; display:inline-flex; align-items:center; justify-content:center; font-size:8px; font-weight:700; cursor:pointer; flex-shrink:0; }
.kpi-info-btn { position:absolute; top:4px; right:4px; width:14px; height:14px; background:rgba(0,0,0,0.1); border-radius:50%; display:inline-flex; align-items:center; justify-content:center; font-size:8px; font-weight:700; cursor:pointer; color:inherit; }

/* Tooltips — toggle (fixed overlay) */
.tooltip-overlay { position:fixed; top:0; left:0; right:0; bottom:0; z-index:250; background:transparent; }
.tooltip-fixed { position:fixed; background:#1a2744; color:#fff; padding:10px 14px; border-radius:8px; font-size:12px; line-height:1.5; max-width:280px; min-width:180px; z-index:300; box-shadow:0 4px 16px rgba(0,0,0,0.25); font-weight:400; }
/* Tooltips — KPI (absolute within card) */
.tooltip-info { position:absolute; top:auto; bottom:110%; left:50%; transform:translateX(-50%); background:#1a2744; color:#fff; padding:8px 12px; border-radius:6px; font-size:11px; line-height:1.4; width:220px; z-index:200; font-weight:400; box-shadow:0 4px 12px rgba(0,0,0,0.2); }
.tooltip-info-kpi { }

/* Tabla */
.tabla-wrap { border:1px solid #dbe1ec; border-radius:8px; overflow:hidden; margin-bottom:12px; }
.tabla-scroll { overflow-x:auto; -webkit-overflow-scrolling:touch; }
.tabla-prod { width:100%; border-collapse:collapse; font-size:11px; }
.tabla-prod th { position:sticky; top:0; z-index:2; background:#1a2744; color:white; font-size:10px; font-weight:600; padding:0.5em 0.4em; text-align:center; white-space:nowrap; }
.tabla-prod td { padding:0.3em 0.4em; border-bottom:1px solid #eef1f7; vertical-align:middle; }
.th-orden { cursor:pointer; user-select:none; }
.orden-ind { font-size:9px; color:#7c8db0; }
.orden-ind-activo { color:#fff; font-weight:700; }
.col-sticky { position:sticky; left:0; z-index:3; background:inherit; }
.col-codigo { min-width:55px; max-width:70px; font-size:11px; font-weight:600; text-align:center; white-space:nowrap; }
thead .col-codigo { z-index:4; background:#0f1b30; }
.fila-alt td { background:#f8f9fb; }
.fila-alt .col-sticky { background:#f8f9fb; }
.fila-persona td { background:#fff; }
.fila-persona .col-sticky { background:#fff; }
.fila-alt .col-sticky { background:#f8f9fb; }

/* Columnas mes */
.col-mes { min-width:90px; padding:0.2em 0.3em !important; vertical-align:middle; text-align:center; }
.col-mes-activo { background:rgba(13,110,253,0.05) !important; }
.col-mes-futuro { background:#fafafa; color:#ccc; }
.col-total { min-width:70px; text-align:right; font-weight:600; }
.col-num { min-width:45px; text-align:right; font-size:10px; }
.col-sep-left { border-left:2px solid #c8d0de !important; }
thead .col-sep-left { border-left:2px solid #3d5278 !important; }

/* Celdas multi-valor */
.celda-mes { display:flex; flex-direction:column; gap:1px; align-items:center; font-size:11px; }
.val-line { display:flex; align-items:center; justify-content:flex-end; gap:3px; white-space:nowrap; line-height:1.2; font-weight:500; }
.vdot { display:inline-block; width:7px; height:7px; border-radius:50%; flex-shrink:0; }
.mes-vacio { color:#ccc; }

/* Footer */
.fila-totales td { background:#eef1f7; font-size:11px; font-weight:500; padding:0.4em 0.35em; border-top:2px solid #c8d0de; color:#1a2744; text-align:right; }
.fila-totales .col-sticky { background:#eef1f7; }
.fila-num-ic td { background:#f0faf5; font-size:10px; font-weight:500; padding:0.3em 0.35em; color:#198754; text-align:right; }
.fila-num-ic .col-sticky { background:#f0faf5; }
.fila-prod-ic td { background:#f0faf5; font-size:10px; font-weight:600; padding:0.3em 0.35em; color:#198754; text-align:right; }
.fila-prod-ic .col-sticky { background:#f0faf5; }
.fila-num-hic td { background:#E6F1FB; font-size:10px; font-weight:500; padding:0.3em 0.35em; color:#0C447C; text-align:right; }
.fila-num-hic .col-sticky { background:#E6F1FB; }
.fila-prod-hic td { background:#E6F1FB; font-size:10px; font-weight:600; padding:0.3em 0.35em; color:#0C447C; text-align:right; }
.fila-prod-hic .col-sticky { background:#E6F1FB; }
.fila-personas td { background:#f5f7fa; font-size:10px; font-weight:500; padding:0.3em 0.35em; color:#7c8db0; }
.fila-personas .col-sticky { background:#f5f7fa; }
.fila-prod-persona td { background:#f0f4fa; font-size:11px; font-weight:500; padding:0.3em 0.35em; color:#1a2744; text-align:right; }
.fila-prod-persona .col-sticky { background:#f0f4fa; }

/* Filtro popup */
.filtro-overlay { position:fixed; top:0; left:0; right:0; bottom:0; z-index:99; background:rgba(0,0,0,0.1); }
.filtro-popup { position:fixed; top:120px; left:300px; z-index:100; background:#fff; border:1px solid #dbe1ec; border-radius:8px; box-shadow:0 6px 20px rgba(0,0,0,0.2); min-width:240px; color:#333; font-weight:400; text-align:left; }

/* Fichaje popup */
.fichaje-overlay { position:fixed; top:0; left:0; right:0; bottom:0; z-index:99; background:rgba(0,0,0,0.3); }
.fichaje-popup { position:fixed; top:50%; left:50%; transform:translate(-50%,-50%); z-index:100; background:#fff; border-radius:10px; box-shadow:0 8px 30px rgba(0,0,0,0.25); width:600px; max-height:80vh; display:flex; flex-direction:column; overflow:hidden; }
.fichaje-header { background:#1a2744; color:#fff; padding:12px 16px; display:flex; justify-content:space-between; align-items:center; flex-shrink:0; }
.fichaje-kpis { display:flex; gap:8px; padding:12px 16px; flex-shrink:0; }
.fk-card { flex:1; border-radius:6px; padding:8px; text-align:center; }
.fk-label { font-size:9px; text-transform:uppercase; font-weight:600; margin-bottom:2px; }
.fk-val { font-size:18px; font-weight:700; }
.fk-azul { background:#E6F1FB; color:#0C447C; } .fk-azul .fk-label { color:#0C447C; }
.fk-purpura { background:#EDE9FE; color:#5B21B6; } .fk-purpura .fk-label { color:#5B21B6; }
.fk-verde { background:#E8F5E9; color:#1B5E20; } .fk-verde .fk-label { color:#1B5E20; }
.fk-rojo { background:#FEE2E2; color:#991B1B; } .fk-rojo .fk-label { color:#991B1B; }
.fichaje-tabla-wrap { overflow-y:auto; flex:1; padding:0 16px 12px; }
.fichaje-tabla { width:100%; border-collapse:collapse; font-size:12px; }
.fichaje-tabla th { background:#f5f7fa; font-size:10px; font-weight:600; color:#7c8db0; padding:4px 6px; text-align:left; position:sticky; top:0; }
.fichaje-tabla td { padding:3px 6px; border-bottom:1px solid #f0f2f5; }
.fich-finde td { background:#fafafa; color:#bbb; }
.fich-vacio td { color:#ddd; }
.fich-rangos { font-size:11px; }
.fich-vac td { background:#FFF9E6; }
.fich-baja td { background:#FEE2E2; }
.fich-fiesta td { background:#E6F1FB; }
.fich-comp td { background:#EDE9FE; }

/* Guia de uso */
.guia-overlay { position:fixed; top:0; left:0; right:0; bottom:0; z-index:200; background:rgba(0,0,0,0.4); }
.guia-popup { position:fixed; top:50%; left:50%; transform:translate(-50%,-50%); z-index:201; width:650px; max-height:85vh; background:#fff; border-radius:12px; box-shadow:0 8px 30px rgba(0,0,0,0.25); display:flex; flex-direction:column; overflow:hidden; }
.guia-hdr { background:linear-gradient(135deg,#1a2744,#2d5f8a); padding:14px 16px 12px; display:flex; justify-content:space-between; align-items:center; flex-shrink:0; }

/* Leyenda */
.leyenda-prod { padding:0.6em 0.8em; display:flex; gap:1.2em; flex-wrap:wrap; font-size:11px; color:#7c8db0; }
.ley-item { display:flex; align-items:center; gap:4px; }
.ley-dot { display:inline-block; width:8px; height:8px; border-radius:50%; }

/* #16 · sello de "de cuando son estos datos", mismo sitio en todas las pantallas. */
.sello-datos-bar { padding: 6px 16px 0; display: flex; flex-wrap: wrap; gap: 8px; }
</style>

<script>
import { unwrapDto } from '../../js/db/responseUtils.js';
import Oeb from '../../js/db/Oeb.js';
import InfoIcon from '../../components/InfoIcon.vue';
import SelloDatos from '../../components/SelloDatos.vue';
import carrilPeticiones from '../../js/utils/carrilPeticiones.js';
import cerrojoDeLaSesion from '../../js/utils/cerrojoDeLaSesion.js';

export default {
  components: { InfoIcon, SelloDatos },
  // #769 · El año va por el carril común de la #472, uno para la tabla y otro para la plantilla de
  // personas, que llega por su lado. Sin él, la respuesta de un año anterior que llegaba tarde se
  // pintaba bajo el año nuevo —con su configuración, sus vistas y sus personas ocultas— y apagaba
  // el «cargando»; y mientras cargaba se seguía viendo la tabla del año de antes.
  created: function() {
    const self = this;
    self.carrilAnio = carrilPeticiones({
      deAhora: function() { return [self.anio]; },
      vaciar: function() { self.datos = null; },
      cargando: function(si) { self.cargando = si; }
    });
    self.carrilPlantilla = carrilPeticiones({
      deAhora: function() { return [self.anio]; },
      vaciar: function() { self.plantillaPersonas = {}; }
    });
  },
  beforeDestroy: function() {
    // El recálculo que se descarta al salir no tiene que volver a leer.
    this.cerrada = true;
    this.carrilAnio.invalidar();
    this.carrilPlantilla.invalidar();
  },
  data: function() {
    return {
      anio: new Date().getFullYear(),
      datos: null,
      configLocal: { horasLaborablesAnuales: 1764, diasVacacionesConvenio: 23 },
      cargando: false,
      guardando: false,
      recalculando: false,
      zoom: 100,
      personasOcultas: {},
      tooltipToggle: null,
      tooltipTogglePos: {},
      tooltipKpi: null,
      togglesDef: [
        { clave: 'tpc', claveConcepto: 'OEB_TPC_SI', nombre: 'TPC(SI)', color: '#dc3545', desc: 'Importe real de reparto con TPC confirmado. Producci\u00f3n ejecutada y verificada.' },
        { clave: 'dh', claveConcepto: 'OEB_DH', nombre: 'D.H', color: '#6c757d', desc: 'D\u00edas h\u00e1biles del mes. Laborables menos fiestas.' },
        { clave: 'vac', claveConcepto: 'OEB_VAC', nombre: 'VAC', color: '#e6a817', desc: 'D\u00edas de vacaciones detectados del calendario.' },
        { clave: 'bl', claveConcepto: 'OEB_BL', nombre: 'BL', color: '#B71C1C', desc: 'D\u00edas de baja laboral detectados del calendario.' },
        { clave: 'dr', claveConcepto: 'OEB_DR', nombre: 'D.R', color: '#555', desc: 'D\u00edas reales = D.H \u2212 VAC \u2212 BL. Capacidad real del mes.' },
        { clave: 'hFichaje', claveConcepto: 'OEB_HorasFichaje', nombre: 'H.fich', color: '#0d6efd', desc: 'Horas de fichaje reales. Click en el valor abre detalle diario.' },
        { clave: 'hMensuales', claveConcepto: 'OEB_HorasMensuales', nombre: 'H.mens', color: '#7B2D8E', desc: 'Horas mensuales te\u00f3ricas = D.R \u00d7 H.D. Capacidad estimada.' },
        { clave: 'deltaH', claveConcepto: 'OEB_DeltaH', nombre: '\u0394H', color: '#E65100', desc: 'Incremento horas = H.fich \u2212 H.mens. Verde si fich\u00f3 de m\u00e1s, rojo si de menos.' },
        { clave: 'sumDeltaH', claveConcepto: 'OEB_SumDeltaH', nombre: '\u03a3\u0394H', color: '#BF360C', desc: 'Sumatorio acumulado de \u0394H desde enero. Desviaci\u00f3n acumulada.' },
        { clave: 'numIc', claveConcepto: 'OEB_NumIC', nombre: 'N\u00ba I/C', color: '#198754', desc: 'N\u00famero de inspectores/consultores equivalentes. Coeficiente de capacidad.' },
        { clave: 'comp', claveConcepto: 'OEB_CO', nombre: 'Comp.', color: '#e6a817', desc: 'Horas de compensaci\u00f3n (T0070). Tiempo compensado fuera de jornada.' },
        { clave: 'prodDia', claveConcepto: 'OEB_ProdDia', nombre: 'Prod/d\u00eda', color: '#1a2744', desc: 'Productividad diaria = TPC(SI) / D.R. Producci\u00f3n por d\u00eda trabajado.' },
        { clave: 'prodH', claveConcepto: 'OEB_ProdH', nombre: 'Prod/h', color: '#1a2744', desc: 'Productividad hora = Prod/d\u00eda / H.D. Producci\u00f3n por hora te\u00f3rica.' }
      ],
      kpisDef: [
        { desc: 'Horas de trabajo anuales seg\u00fan convenio. Editable manualmente.' },
        { desc: 'Suma de horas reales fichadas en meses vencidos. Dato real del sistema de fichaje.' },
        { desc: 'D\u00edas de vacaciones anuales por convenio. Editable manualmente.' },
        { desc: 'Suma de d\u00edas de vacaciones detectados hasta el mes anterior al actual.' },
        { desc: 'D\u00edas convenio \u2212 Consumidas. Vacaciones pendientes de disfrutar.' },
        { desc: 'Horas de compensaci\u00f3n (T0070) acumuladas en meses vencidos.' },
        { desc: 'TPC total / (d\u00edas fichados \u00d7 8h). Producci\u00f3n por hora de presencia real.' },
        { desc: 'Suma D.R. \u00d7 H.D. de meses vencidos. Capacidad te\u00f3rica en horas I/C.' },
        { desc: 'TPC total / N\u00ba H. I/C. Producci\u00f3n por hora te\u00f3rica de capacidad inspectora.' },
        { desc: 'TPC total / meses vencidos / media personas. Producci\u00f3n mensual media por persona.' },
        { desc: 'TPC total / suma N\u00ba I/C meses vencidos. Producci\u00f3n por inspector equivalente.' }
      ],
      popupInfo: false,
      instrucciones: [],
      buscarInstr: '',
      expandedInst: null,
      popupFiltro: false,
      popupFichaje: false,
      fichajeDetalle: null,
      fichajePersonaCod: null,
      fichajeMes: 0,
      cargandoFichaje: false,
      nombresMeses: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'],
      plantillaPersonas: {},
      popupPlantillaAbierto: false,
      plantillaPersonasEdit: {
        1:{totalPersonas:null,comentario:''}, 2:{totalPersonas:null,comentario:''},
        3:{totalPersonas:null,comentario:''}, 4:{totalPersonas:null,comentario:''},
        5:{totalPersonas:null,comentario:''}, 6:{totalPersonas:null,comentario:''},
        7:{totalPersonas:null,comentario:''}, 8:{totalPersonas:null,comentario:''},
        9:{totalPersonas:null,comentario:''}, 10:{totalPersonas:null,comentario:''},
        11:{totalPersonas:null,comentario:''}, 12:{totalPersonas:null,comentario:''}
      },
      plantillaGuardando: false,
      // #36 · orden de presentacion de las filas de persona. campo null = el que llega
      // de la API. No se guarda en configLocal: se pierde al salir de la pantalla.
      orden: { campo: null, dir: 1 },
      toggles: {
        tpc: true,
        dh: false,
        vac: false,
        bl: false,
        dr: true,
        hFichaje: false,
        hMensuales: false,
        deltaH: false,
        sumDeltaH: false,
        numIc: false,
        comp: false,
        prodDia: true,
        prodH: false,
        soloProduccion: false
      }
    };
  },
  computed: {
    personasFiltradas: function() {
      if (!this.datos || !this.datos.personas) return [];
      var self = this;
      return this.datos.personas.filter(function(p) {
        if (self.personasOcultas[p.codigo]) return false;
        if (self.toggles.soloProduccion && !p.tieneProduccion) return false;
        return true;
      });
    },
    // #36 · Solo para pintar el v-for. Los totales, la numeracion de fichaje y los KPI
    // siguen leyendo personasFiltradas, asi que ninguna cifra depende del orden elegido.
    personasOrdenadas: function() {
      var campo = this.orden.campo;
      if (!campo) return this.personasFiltradas;
      var self = this;
      var dir = this.orden.dir;
      // Se ordena una copia indexada: la copia evita mutar personasFiltradas y el indice
      // deshace los empates con el orden de la API, sin depender de que sort sea estable.
      var filas = this.personasFiltradas.map(function(p, i) { return { p: p, i: i }; });
      filas.sort(function(a, b) {
        var va = self.valorOrden(a.p, campo);
        var vb = self.valorOrden(b.p, campo);
        if (va === null && vb === null) return a.i - b.i;
        if (va === null) return 1;
        if (vb === null) return -1;
        var cmp = typeof va === 'string'
          ? va.localeCompare(vb, 'es', { numeric: true, sensitivity: 'base' })
          : va - vb;
        return cmp === 0 ? a.i - b.i : cmp * dir;
      });
      return filas.map(function(f) { return f.p; });
    },
    numOcultas: function() {
      var c = 0;
      for (var k in this.personasOcultas) { if (this.personasOcultas[k]) c++; }
      return c;
    },
    todasLasPersonas: function() {
      if (!this.datos || !this.datos.personas) return [];
      return this.datos.personas;
    },
    kpiHorasFichadas: function() {
      if (!this.datos || !this.datos.personas) return 0;
      var total = 0;
      this.datos.personas.forEach(function(p) { total += (p.totalHFichaje || 0); });
      return Math.round(total);
    },
    kpiVacConsumidas: function() {
      if (!this.datos || !this.datos.personas) return 0;
      var total = 0;
      this.datos.personas.forEach(function(p) { total += (p.totalVac || 0); });
      return total;
    },
    kpiVacRestantes: function() {
      var convenio = (this.configLocal.diasVacacionesConvenio || 23);
      var numPersonas = this.datos && this.datos.personas ? this.datos.personas.length : 0;
      return convenio * numPersonas - this.kpiVacConsumidas;
    },
    kpiHorasComp: function() {
      if (!this.datos || !this.datos.personas) return 0;
      var total = 0;
      this.datos.personas.forEach(function(p) { total += (p.totalComp || 0); });
      return Math.round(total);
    },
    kpiPrecioMedioH: function() {
      if (!this.datos || !this.datos.personas) return '0';
      var totalTpc = 0, totalDiasFichados = 0;
      var mv = this.datos.mesesVencidos || 0;
      var self = this;
      this.datos.personas.forEach(function(p) {
        totalTpc += (p.totalTpc || 0);
        if (p.meses) {
          for (var i = 0; i < mv && i < 12; i++) {
            if (p.meses[i]) totalDiasFichados += (p.meses[i].diasFichaje || 0);
          }
        }
      });
      var horasTeoricas = totalDiasFichados * 8;
      if (horasTeoricas <= 0) return '0';
      return (totalTpc / horasTeoricas).toFixed(1).replace('.', ',');
    },
    kpiNumHIC: function() {
      if (!this.datos || !this.datos.personas) return 0;
      var total = 0;
      var mv = this.datos.mesesVencidos || 0;
      this.datos.personas.forEach(function(p) {
        if (p.meses) {
          for (var i = 0; i < mv && i < 12; i++) {
            if (p.meses[i]) total += (p.meses[i].hMensuales || 0);
          }
        }
      });
      return Math.round(total);
    },
    kpiPrecioMedioICH: function() {
      if (this.kpiNumHIC <= 0) return '0';
      var totalTpc = 0;
      this.datos.personas.forEach(function(p) { totalTpc += (p.totalTpc || 0); });
      return (totalTpc / this.kpiNumHIC).toFixed(1).replace('.', ',');
    },
    kpiProdIc: function() {
      if (!this.datos || !this.datos.personas) return 0;
      var totalTpc = 0, totalIc = 0;
      var self = this;
      this.datos.personas.forEach(function(p) {
        totalTpc += (p.totalTpc || 0);
        if (p.meses) {
          for (var i = 0; i < self.datos.mesesVencidos && i < 12; i++) {
            if (p.meses[i]) totalIc += (p.meses[i].numIc || 0);
          }
        }
      });
      return totalIc > 0 ? Math.round(totalTpc / totalIc) : 0;
    },
    grandTotal: function() {
      if (!this.personasFiltradas.length) return { tpc: 0, prodDia: 0, prodH: 0, vac: 0, vacRest: 0 };
      var tpc = 0, dr = 0, hm = 0, vac = 0;
      this.personasFiltradas.forEach(function(p) {
        tpc += (p.totalTpc || 0);
        dr += (p.totalDR || 0);
        hm += (p.totalHMensuales || 0);
        vac += (p.totalVac || 0);
      });
      var convenio = (this.configLocal.diasVacacionesConvenio || 23) * this.personasFiltradas.length;
      return {
        tpc: Math.round(tpc),
        prodDia: dr > 0 ? Math.round(tpc / dr) : 0,
        prodH: hm > 0 ? Math.round(tpc / hm) : 0,
        vac: vac,
        vacRest: convenio - vac
      };
    },
    grandTotalNumIc: function() {
      if (!this.datos || !this.datos.personas) return 0;
      var mv = this.datos.mesesVencidos || 0;
      if (mv <= 0) return 0;
      var total = 0;
      var self = this;
      this.personasFiltradas.forEach(function(p) {
        if (p.meses) {
          for (var i = 0; i < mv && i < 12; i++) {
            if (p.meses[i]) total += (p.meses[i].numIc || 0);
          }
        }
      });
      return Math.round(total / mv * 10) / 10;
    },
    instFiltradas: function() {
      var q = (this.buscarInstr || '').toLowerCase();
      if (!q) return this.instrucciones;
      return this.instrucciones.filter(function(i) {
        return (i.titulo || '').toLowerCase().indexOf(q) > -1 || (i.texto || '').toLowerCase().indexOf(q) > -1;
      });
    },
    tooltipToggleData: function() {
      if (!this.tooltipToggle) return { nombre: '', desc: '' };
      for (var i = 0; i < this.togglesDef.length; i++) {
        if (this.togglesDef[i].clave === this.tooltipToggle) return this.togglesDef[i];
      }
      return { nombre: '', desc: '' };
    },
    fichajeDetalleDelta: function() {
      if (!this.fichajeDetalle || !this.fichajePersonaCod || !this.datos) return 0;
      var cod = this.fichajePersonaCod;
      var m = this.fichajeMes;
      var hFich = (this.fichajeDetalle.totalMinutosMes || 0) / 60.0;
      var hMens = 0;
      var persona = null;
      if (this.datos.personas) {
        for (var i = 0; i < this.datos.personas.length; i++) {
          if (this.datos.personas[i].codigo === cod) { persona = this.datos.personas[i]; break; }
        }
      }
      if (persona && persona.meses && persona.meses[m - 1]) hMens = persona.meses[m - 1].hMensuales || 0;
      return hFich - hMens;
    },
    mediaPersonasMes: function() {
      if (!this.datos || !this.datos.mesesVencidos || this.datos.mesesVencidos <= 0) return 0;
      var suma = 0;
      for (var m = 1; m <= this.datos.mesesVencidos; m++) {
        suma += this.getPersonasProporcionalMes(m);
      }
      return suma / this.datos.mesesVencidos;
    },
    totalPersonasCalculo: function() {
      return (this.datos ? (this.datos.totalPersonas || 0) : 0) + 2;
    },
    mediaProdIC: function() {
      var mv = this.datos ? (this.datos.mesesVencidos || 0) : 0;
      if (mv <= 0) return 0;
      var suma = 0, mesesConDatos = 0;
      for (var m = 1; m <= mv; m++) {
        var tm = this.totalMes(m);
        if (tm && tm.numIc > 0 && tm.tpcSi > 0) { suma += tm.tpcSi / tm.numIc; mesesConDatos++; }
      }
      return mesesConDatos > 0 ? Math.round(suma / mesesConDatos) : 0;
    },
    mediaProdHIC: function() {
      var mv = this.datos ? (this.datos.mesesVencidos || 0) : 0;
      if (mv <= 0) return 0;
      var suma = 0, mesesConDatos = 0;
      for (var m = 1; m <= mv; m++) {
        var tm = this.totalMes(m);
        if (tm && tm.hMensuales > 0 && tm.tpcSi > 0) { suma += tm.tpcSi / tm.hMensuales; mesesConDatos++; }
      }
      return mesesConDatos > 0 ? Math.round(suma / mesesConDatos * 10) / 10 : 0;
    },
    prodPorPersona: function() {
      var mesesVencidos = this.datos ? (this.datos.mesesVencidos || 0) : 0;
      if (mesesVencidos <= 0 || this.mediaPersonasMes <= 0) return 0;
      var produccionMensualMedia = (this.grandTotal.tpc || 0) / mesesVencidos;
      return Math.round(produccionMensualMedia / this.mediaPersonasMes);
    }
  },
  methods: {
    onPageInit: function() {
      this.cargarDatos();
    },
    cargarDatos: function() {
      var self = this;
      // #769 · La plantilla de personas solo depende del año: se pide a la vez que la tabla y no
      // cuando esta ha llegado, que eran dos viajes seguidos para lo que es uno.
      self.fetchPlantillaPersonas();
      self.carrilAnio.lanzar(Oeb.getProductividadAnual(self.anio), {
        exito: function(res) {
          if (unwrapDto(res)) {
            self.datos = unwrapDto(res);
            if (unwrapDto(res).config) {
              var cfg = unwrapDto(res).config;
              self.configLocal = {
                id: cfg.id,
                anio: cfg.anio,
                horasLaborablesAnuales: cfg.horasLaborablesAnuales || 1764,
                diasVacacionesConvenio: cfg.diasVacacionesConvenio || 23,
                horasLaborablesPorPersona: cfg.horasLaborablesPorPersona || {}
              };
              if (cfg.togglesGuardados) {
                for (var t in cfg.togglesGuardados) {
                  if (self.toggles.hasOwnProperty(t)) self.toggles[t] = cfg.togglesGuardados[t];
                }
              }
              if (cfg.personasOcultasGuardadas && cfg.personasOcultasGuardadas.length) {
                var oc = {};
                cfg.personasOcultasGuardadas.forEach(function(c) { oc[c] = true; });
                self.personasOcultas = oc;
              }
            }
          }
        }
      });
    },
    // Por el mismo carril que la carga: si mientras recalcula se cambia de año, lo recalculado es
    // del año de antes y no se pinta.
    recalcular: function() {
      var self = this;
      // #663 · Cerrojo de la sesión: si la sesión cambia en vuelo, la frontera calla la continuación que lo soltaba.
      cerrojoDeLaSesion(self, 'recalculando');
      const anio = self.anio;
      const terminar = function() { self.recalculando = false; };
      self.carrilAnio.lanzar(Oeb.recalcularProductividadAnual(self.anio), {
        exito: function(res) {
          terminar();
          if (unwrapDto(res)) {
            self.datos = unwrapDto(res);
            if (unwrapDto(res).config) {
              var cfg = unwrapDto(res).config;
              self.configLocal = {
                id: cfg.id, anio: cfg.anio,
                horasLaborablesAnuales: cfg.horasLaborablesAnuales || 1764,
                diasVacacionesConvenio: cfg.diasVacacionesConvenio || 23,
                horasLaborablesPorPersona: cfg.horasLaborablesPorPersona || {}
              };
            }
          }
          self.$f7.toast.create({ text: 'Datos recalculados', position: 'top', closeTimeout: 2000, cssClass: 'toast-ok' }).open();
        },
        fallo: terminar,
        // #769 · Si lo adelanta un «Actualizar» del mismo año pulsado mientras recalculaba, esa
        // lectura pudo salir del servidor antes de que el recálculo terminara de escribir y
        // pintaría lo de antes: con el recálculo hecho, se vuelve a leer lo que ha dejado. Es lo
        // mismo que en Análisis de diferencias (revisión CODEX del PR #1845).
        //
        // Y lo recalculado se anuncia igual que si mandara, con el año dentro porque se puede leer
        // con otro delante: sin el aviso, el recálculo adelantado terminaba sin decir nada
        // (revisión CODEX del PR #1845, ronda 5).
        descartada: function(ok) {
          terminar();
          if (!ok || self.cerrada) return;
          self.$f7.toast.create({ text: 'Datos de ' + anio + ' recalculados', position: 'top', closeTimeout: 2000, cssClass: 'toast-ok' }).open();
          if (self.anio === anio) self.cargarDatos();
        }
      });
    },
    guardarConfig: function() {
      var self = this;
      cerrojoDeLaSesion(self, 'guardando');
      self.configLocal.anio = self.anio;
      self.configLocal.togglesGuardados = Object.assign({}, self.toggles);
      var ocultas = [];
      for (var k in self.personasOcultas) { if (self.personasOcultas[k]) ocultas.push(k); }
      self.configLocal.personasOcultasGuardadas = ocultas;
      Oeb.guardarConfigProductividad(self.configLocal).then(function() {
        self.guardando = false;
        self.$f7.toast.create({ text: 'Configuraci\u00f3n guardada', position: 'top', closeTimeout: 2000, cssClass: 'toast-ok' }).open();
        self.cargarDatos();
      }).catch(function() {
        self.guardando = false;
        self.$f7.toast.create({ text: 'Error al guardar', position: 'top', closeTimeout: 2000 }).open();
      });
    },
    // #36 · TOTAL arranca de mayor a menor (quien mas produce arriba) y COD alfabetico;
    // pulsar de nuevo en la misma cabecera invierte el sentido.
    ordenarPor: function(campo) {
      if (this.orden.campo === campo) {
        this.orden = { campo: campo, dir: -this.orden.dir };
      } else {
        this.orden = { campo: campo, dir: campo === 'total' ? -1 : 1 };
      }
    },
    valorOrden: function(persona, campo) {
      if (campo === 'codigo') {
        var cod = persona.codigo;
        return (cod == null || cod === '') ? null : String(cod);
      }
      var v = persona.totalTpc;
      // Sin dato es solo no traer valor: un 0 es un dato y ordena como tal.
      return (v == null || isNaN(v)) ? null : Number(v);
    },
    indicadorOrden: function(campo) {
      if (this.orden.campo !== campo) return '⇅';
      return this.orden.dir === 1 ? '↑' : '↓';
    },
    nombreMesCorto: function(m) { return this.nombresMeses[m - 1]; },
    claseColumnaMes: function(m) {
      var mesActual = new Date().getMonth() + 1;
      var anioActual = new Date().getFullYear();
      if (this.anio === anioActual && m === mesActual) return 'col-mes-activo';
      if (this.anio > anioActual || (this.anio === anioActual && m > mesActual)) return 'col-mes-futuro';
      return '';
    },
    irAPlanificacion: function(mes) {
      this.$f7router.navigate('/dashboard/oeb/planificacion/?anio=' + this.anio + '&mes=' + mes);
    },
    totalMes: function(m) {
      if (!this.personasFiltradas.length) return null;
      var t = { tpcSi: 0, dh: 0, vac: 0, bl: 0, dr: 0, hMensuales: 0, horasFichaje: 0, numIc: 0, comp: 0, prodDia: 0, prodH: 0 };
      var hayDatos = false;
      this.personasFiltradas.forEach(function(p) {
        if (!p.meses || !p.meses[m - 1]) return;
        hayDatos = true;
        var md = p.meses[m - 1];
        t.tpcSi += (md.tpcSi || 0);
        t.dh += (md.dh || 0);
        t.vac += (md.vac || 0);
        t.bl += (md.bl || 0);
        t.dr += (md.dr || 0);
        t.hMensuales += (md.hMensuales || 0);
        t.horasFichaje += (md.horasFichaje || 0);
        t.numIc += (md.numIc || 0);
        t.comp += (md.comp || 0);
      });
      if (!hayDatos) return null;
      t.prodDia = t.dr > 0 ? Math.round(t.tpcSi / t.dr) : 0;
      t.prodH = t.hMensuales > 0 ? Math.round(t.tpcSi / t.hMensuales) : 0;
      return t;
    },
    vacRestantes: function(persona) {
      var convenio = this.configLocal.diasVacacionesConvenio || 23;
      return convenio - (persona.totalVac || 0);
    },
    fmtNum: function(v) {
      if (v == null || v === 0) return '0';
      if (Math.abs(v) >= 1000) return Math.round(v).toLocaleString('es-ES');
      return Math.round(v).toString();
    },
    fmtDec: function(v) {
      if (v == null || v === 0) return '0';
      return v.toFixed ? v.toFixed(1).replace('.', ',') : v;
    },
    tStyle: function(color, active) {
      if (active) return { background: color, color: '#fff', border: '1px solid ' + color };
      return { background: '#f0f2f5', color: '#666', border: '1px solid #ddd' };
    },
    mostrarNombrePersona: function(persona) {
      var nombre = persona.nombre || persona.codigo;
      this.$f7.dialog.alert(nombre, 'Inspector: ' + persona.codigo);
    },
    togglePersona: function(cod) {
      this.$set(this.personasOcultas, cod, !this.personasOcultas[cod]);
    },
    seleccionarTodas: function() {
      this.personasOcultas = {};
    },
    deseleccionarTodas: function() {
      var self = this;
      if (!this.datos || !this.datos.personas) return;
      this.datos.personas.forEach(function(p) { self.$set(self.personasOcultas, p.codigo, true); });
    },
    cargarInstrucciones: function() {
      var self = this;
      Oeb.getInstrucciones('control-cifras-oeb-productividad').then(function(res) {
        if (unwrapDto(res)) self.instrucciones = unwrapDto(res);
      });
    },
    abrirTooltipToggle: function(event, td) {
      if (this.tooltipToggle === td.clave) { this.tooltipToggle = null; return; }
      this.tooltipToggle = td.clave;
      var rect = event.target.getBoundingClientRect();
      this.tooltipTogglePos = {
        position: 'fixed',
        top: (rect.bottom + 8) + 'px',
        left: Math.max(10, rect.left - 100) + 'px',
        zIndex: 300
      };
    },
    abrirFichajeDetalle: function(persona, m) {
      var self = this;
      self.fichajePersonaCod = persona.codigo;
      self.fichajeMes = m;
      cerrojoDeLaSesion(self, 'cargandoFichaje');
      self.popupFichaje = true;
      self.fichajeDetalle = null;
      Oeb.getFichaje(persona.codigo, self.anio, m)
        .then(function(res) {
          self.cargandoFichaje = false;
          if (unwrapDto(res)) self.fichajeDetalle = unwrapDto(res);
        }).catch(function() { self.cargandoFichaje = false; });
    },
    navFichajeMes: function(dir) {
      var nuevoMes = this.fichajeMes + dir;
      if (nuevoMes < 1 || nuevoMes > 12) return;
      this.fichajeMes = nuevoMes;
      var self = this;
      cerrojoDeLaSesion(self, 'cargandoFichaje');
      self.fichajeDetalle = null;
      Oeb.getFichaje(self.fichajePersonaCod, self.anio, nuevoMes)
        .then(function(res) {
          self.cargandoFichaje = false;
          if (unwrapDto(res)) self.fichajeDetalle = unwrapDto(res);
        }).catch(function() { self.cargandoFichaje = false; });
    },
    fmtMinToH: function(min) {
      if (!min || min <= 0) return '\u2014';
      var h = Math.floor(min / 60);
      var m = min % 60;
      return h + 'h ' + (m < 10 ? '0' : '') + m + 'm';
    },
    fmtDiaSemana: function(dow) {
      return ['', 'Lun', 'Mar', 'Mi\u00e9', 'Jue', 'Vie', 'S\u00e1b', 'Dom'][dow] || '';
    },
    getDeltaH: function(persona, m) {
      if (!persona.meses || !persona.meses[m - 1]) return null;
      var md = persona.meses[m - 1];
      var hMens = md.hMensuales || 0;
      var hFich = md.horasFichaje || 0;
      if (hMens === 0 && hFich === 0) return null;
      return hFich - hMens;
    },
    getSumDeltaH: function(persona, m) {
      var sum = 0;
      var tieneAlguno = false;
      for (var i = 1; i <= m; i++) {
        var delta = this.getDeltaH(persona, i);
        if (delta !== null) { sum += delta; tieneAlguno = true; }
      }
      return tieneAlguno ? sum : null;
    },
    getTotalDeltaH: function(m) {
      var total = 0;
      var self = this;
      this.personasFiltradas.forEach(function(p) {
        var d = self.getDeltaH(p, m);
        if (d !== null) total += d;
      });
      return total;
    },
    getTotalSumDeltaH: function(m) {
      var total = 0;
      var self = this;
      this.personasFiltradas.forEach(function(p) {
        var d = self.getSumDeltaH(p, m);
        if (d !== null) total += d;
      });
      return total;
    },
    getNumPersonaMes: function(persona, m) {
      var count = 0;
      for (var i = 0; i < this.personasFiltradas.length; i++) {
        var p = this.personasFiltradas[i];
        if (p.meses && p.meses[m - 1] && (p.meses[m - 1].horasFichaje || 0) > 0) {
          count++;
          if (p.codigo === persona.codigo) return count;
        }
      }
      return 0;
    },
    getPersonasProporcionalMes: function(m) {
      // Si hay valor manual, sustituye al automatico (Fase 3)
      var manual = this.plantillaPersonas[String(m)];
      if (manual && manual.totalPersonas != null) {
        return manual.totalPersonas;
      }
      if (!this.personasFiltradas || !this.personasFiltradas.length) return 0;
      // D.H. del mes = máximo de dh entre personas (robusto ante dh parcial)
      var diasHabilesMes = 0;
      this.personasFiltradas.forEach(function(p) {
        if (p.meses && p.meses[m - 1]) {
          var dh = p.meses[m - 1].dh || 0;
          if (dh > diasHabilesMes) diasHabilesMes = dh;
        }
      });
      if (diasHabilesMes <= 0) return 0;
      var totalProporcional = 0;
      var algunaFicho = false;
      this.personasFiltradas.forEach(function(p) {
        if (p.meses && p.meses[m - 1]) {
          var df = p.meses[m - 1].diasFichaje || 0;
          if (df > 0) {
            algunaFicho = true;
            totalProporcional += df / diasHabilesMes;
          }
        }
      });
      if (!algunaFicho) return 0;
      return totalProporcional + 2;
    },
    esMesManual: function(m) {
      var manual = this.plantillaPersonas[String(m)];
      return !!(manual && manual.totalPersonas != null);
    },
    tooltipMesManual: function(m) {
      var manual = this.plantillaPersonas[String(m)];
      if (!manual || manual.totalPersonas == null) return '';
      var partes = ['Valor manual: ' + manual.totalPersonas];
      if (manual.comentario) partes.push('Nota: ' + manual.comentario);
      if (manual.modificadoPor && manual.fechaModificacion) {
        var fecha = new Date(manual.fechaModificacion);
        partes.push('Editado: ' + fecha.toLocaleDateString() + ' por ' + manual.modificadoPor);
      }
      return partes.join('\n');
    },
    fmtPersonas: function(v) {
      if (v == null) return '';
      var n = Number(v);
      if (!isFinite(n) || n === 0) return 0;
      var truncado = Math.floor(n * 10) / 10;
      if (truncado === Math.floor(truncado)) return String(Math.floor(truncado));
      return truncado.toFixed(1).replace('.', ',');
    },
    contarPersonasMes: function(m) {
      var count = 0;
      this.personasFiltradas.forEach(function(p) {
        if (p.meses && p.meses[m - 1] && ((p.meses[m - 1].tpcSi || 0) > 0 || (p.meses[m - 1].dr || 0) > 0)) count++;
      });
      return count > 0 ? count : '';
    },
    zoomIn: function() { if (this.zoom < 150) this.zoom += 10; },
    zoomOut: function() { if (this.zoom > 50) this.zoom -= 10; },
    nombreMesLargo: function(m) {
      var nombres = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
      return nombres[m - 1];
    },
    fetchPlantillaPersonas: function() {
      var self = this;
      if (!self.anio) return;
      self.carrilPlantilla.lanzar(Oeb.getPersonasPlantilla(self.anio), {
        exito: function(res) {
          var pm = {};
          (res && unwrapDto(res) ? unwrapDto(res) : []).forEach(function(item) {
            pm[String(item.mes)] = {
              totalPersonas: item.totalPersonas,
              comentario: item.comentario,
              modificadoPor: item.modificadoPor,
              fechaModificacion: item.fechaModificacion
            };
          });
          self.plantillaPersonas = pm;
        },
        limpiar: function() { self.plantillaPersonas = {}; }
      });
    },
    abrirPopupPlantilla: function() {
      var edit = {};
      for (var m = 1; m <= 12; m++) {
        var existente = this.plantillaPersonas[String(m)] || {};
        edit[m] = {
          totalPersonas: existente.totalPersonas != null ? existente.totalPersonas : null,
          comentario: existente.comentario || ''
        };
      }
      this.plantillaPersonasEdit = edit;
      this.popupPlantillaAbierto = true;
    },
    guardarPlantilla: function() {
      var self = this;
      cerrojoDeLaSesion(self, 'plantillaGuardando');
      var batch = [];
      for (var m = 1; m <= 12; m++) {
        var row = self.plantillaPersonasEdit[m] || {};
        var val = row.totalPersonas;
        batch.push({
          anio: self.anio,
          mes: m,
          totalPersonas: (val === '' || val == null) ? null : Number(val),
          comentario: row.comentario || ''
        });
      }
      Oeb.actualizarPersonasPlantillaBatch(batch)
      .then(function() {
        self.plantillaGuardando = false;
        self.popupPlantillaAbierto = false;
        self.fetchPlantillaPersonas();
        self.$f7.toast.create({ text: 'Plantilla guardada', closeTimeout: 2500, position: 'bottom' }).open();
      })
      .catch(function() {
        self.plantillaGuardando = false;
        self.$f7.toast.create({ text: 'Error al guardar. Comprueba permisos.', closeTimeout: 3500, position: 'bottom' }).open();
      });
    }
  }
};
</script>
